.editable-label {
    color: var(--grey-dk);
    cursor: pointer;
    transition: color linear 100ms;
    padding: 4px;
    text-align: left; /* Overrides default button styling of `text-align: center;` */
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid transparent;
    border-radius: 3px;
}

.editable-label-container {
    display: flex;
    /* The height of the text, plus the padding */
    height: calc(1em + 8px);
}

.editable-label-container--centered {
    align-items: center;
}

.editable-label-container--truncate {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.editable-label:hover,
.editable-label:focus {
    box-sizing: border-box;
    border: 1px solid var(--off-white-dk);
}

.editable-label--header {
    display: flex;
    align-items: center;
    color: var(--grey);
    font-size: var(--font-normal);
}

.editable-label-input--header {
    font-size: var(--font-normal);
    color: var(--grey);
    line-height: 19px;
}

.editable-label--empty {
    color: var(--placeholder);
}

.editable-label--failure {
    color: var(--rose);
}

.editable-label--saving {
    color: var(--grey-lt);
}

.editable-label-input {
    composes: editable-label;
    outline: none;
    border: none;
    transition: color linear 100ms;
    background-color: unset;
    font-weight: inherit;
}

.editable-label-input::-webkit-input-placeholder {
    color: var(--placeholder);
}

.editable-label--required {
    right: -7px;
}

.editable-label--required::after {
    content: '*';
    color: var(--rose);
    padding-left: 2px;
}

.editable-label--white:hover,
.editable-label--white:focus {
    background-color: white;
    outline: none;
    padding-left: 0;
    margin-left: 0;
}

.editable-label-input--white {
    composes: editable-label;
    outline: none;
    border: none;
    transition: color linear 100ms;
    background-color: white;
    font-weight: inherit;
    padding-left: 0; /* This ensures the input is in the same position as the label */
    margin-left: 0; /* This ensures the input is in the same position as the label */
}
